/**
 * @generated SignedSource<<e6a0cb148ebce742746ee6d822d5b96f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SearchPeekQuery$variables = {
  searchID: number;
};
export type SearchPeekQuery$data = {
  readonly viewer: {
    readonly savedsearch: {
      readonly rateType: number | null;
      readonly rates: {
        readonly rawBillRates: ReadonlyArray<number | null> | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"BellCurveBillRates_savedsearch">;
    } | null;
  } | null;
};
export type SearchPeekQuery = {
  response: SearchPeekQuery$data;
  variables: SearchPeekQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "searchID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rateType",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawBillRates",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchPeekQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SaveSearchNode",
            "kind": "LinkedField",
            "name": "savedsearch",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RateSearchResponse",
                "kind": "LinkedField",
                "name": "rates",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BellCurveBillRates_savedsearch"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SearchPeekQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SaveSearchNode",
            "kind": "LinkedField",
            "name": "savedsearch",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RateSearchResponse",
                "kind": "LinkedField",
                "name": "rates",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "perDiem",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rawMin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rawAvg",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rawMid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rawMax",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrencyNode",
                "kind": "LinkedField",
                "name": "currency",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iso",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "97c275ea61e4fef43829826307d2f9d3",
    "id": null,
    "metadata": {},
    "name": "SearchPeekQuery",
    "operationKind": "query",
    "text": "query SearchPeekQuery(\n  $searchID: Int!\n) {\n  viewer {\n    savedsearch(id: $searchID) {\n      rateType\n      rates {\n        rawBillRates\n      }\n      ...BellCurveBillRates_savedsearch\n      id\n    }\n  }\n}\n\nfragment BellCurveBillRates_savedsearch on SaveSearchNode {\n  id\n  currency {\n    id\n    iso\n  }\n  rates {\n    rawBillRates\n    perDiem\n    rawMin\n    rawAvg\n    rawMid\n    rawMax\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ab25cd8ca8c6ac5f70836f8a1a0acce";

export default node;
